import React, { Component } from 'react';
import Modal from '../../../../ui/modal/Modal';

const styles = {
  footerBar: {
    'position':'fixed',
    'bottom':'0',
    'height': '7em',
    'backgroundColor':'#33485c',
    'width':'100%',
    'zIndex': '10',
    'textAlign': 'center'
  },
  footerButtons: {
    position: 'relative',
    transform: 'translate(-50%,-50%)',
    top: '50%',
    left: '50%'
  },
}

class FooterButtons extends Component {
  constructor(props) {
        super(props)

        this.state = {
            showModal: false,
            showWarningModal: false,
            modalText: '',
            accept: false,
        }
  }
  onToggleModal = () => {
    this.setState({
        showModal: this.state.showModal ? false : true
    });
  }
  onChange = (e) => {
    this.setState({
        [e.target.name]: e.target.checked
    })
  }
  onHandleDelete = (e) => {
    e.preventDefault();
    if(!this.state.accept) {
        this.setState({
            showWarningModal: true,
            showModal: false,
            modalText: 'Du skal godkende betingelserne'
        });
    } else {
        this.setState({
            showModal: false
        });
        this.props.onHandleDelete()
    }
  }
  render() {
    const {user, organizationId, onHandleDelete, onBackToOverview, onSubmit} = this.props;
    return(
      <div>
        <div style={styles.footerBar}>
            {user.type==="admin" ?
              <AdminButtons onToggleModal={this.onToggleModal} onBackToOverview={onBackToOverview} onSubmit={onSubmit} organizationId={organizationId} btnSubmitDisabled={this.props.btnSubmitDisabled} />
              :
              <UserButtons onSubmit={onSubmit} btnSubmitDisabled={this.props.btnSubmitDisabled} />
            }
        </div>
        <Modal visible={this.state.showModal}><h4>Fjern trossamfund/menighed fra register</h4>
          <div style={{marginTop: '1em'}}>
            Er du helt sikker på om du vil fjerne trossamfundet/menigheden fra registeret? Fjernes kun hvis trossamfund/menighed ikke længere er anerkendt.
          </div>
          <div style={{marginTop: '1em'}}>
            <label style={{fontSize: '1em', padding: 0, margin: 0}}>
              <input type="checkbox" name="accept" onChange={this.onChange} checked={this.state.accept} />
                Dokumentation er journaliseret i ESDH-systemet.
            </label>
            <div style={{marginTop: '1em'}}>
              <button type="button" className="button" onClick={() => this.onToggleModal()}>Annuller</button>
              <button type="button" className="button sienna" onClick={this.onHandleDelete}>Ja - Fjern</button>
            </div>
          </div>
        </Modal>
        <Modal visible={this.state.showWarningModal}>
            <p>{this.state.modalText}</p>
            <div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
                <button type="button" className="button" onClick={() => this.setState({showWarningModal: false, showModal: true})}>Ok</button>
            </div>
          </Modal>
      </div>
    )
  }
}

const AdminButtons = (props) => {
  if(props.organizationId > 0) {
    return(
      <div style={styles.footerButtons}>
        <button className="button large sienna button--footer" type="button" onClick={props.onToggleModal}>Fjern</button>
        <button className="button large summer button--footer" type="button" onClick={props.onBackToOverview}>Tilbage til oversigt</button>
        <button className="button large ocean button--footer" type="button" onClick={props.onSubmit} disabled={props.btnSubmitDisabled}>Gem og luk</button>
        <button className="button large ocean button--footer" type="button" onClick={(e) => props.onSubmit(e, 'save')} disabled={props.btnSubmitDisabled}>Gem</button>
      </div>
    )
  } else {
    return(
      <div style={styles.footerButtons}>
        <button className="button large summer button--footer" type="button" onClick={props.onBackToOverview}>Tilbage til oversigt</button>
        <button className="button large ocean button--footer" type="button" onClick={props.onSubmit} disabled={props.btnSubmitDisabled}>Gem og luk</button>
        <button className="button large ocean button--footer" type="button" onClick={(e) => props.onSubmit(e)} disabled={props.btnSubmitDisabled}>Gem</button>
      </div>
      )
  }
}

const UserButtons = (props) => {
  return(
      <div style={styles.footerButtons}>
        <button className="button large ocean button--footer" type="button" onClick={(e) => props.onSubmit(e, 'save')} disabled={props.btnSubmitDisabled}>Gem</button>
        <div style={{textAlign: 'center', color: '#fff', marginTop: '.5em'}}>Husk at trykke på gem, inden du forlader siden for at gemme dine ændringer</div>
      </div>
    )
}

export default FooterButtons;


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/FooterButtons.js